<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps({
  height: String,
  width: String
});
const heightComputed = computed(() => props.height?.includes('%') ? props.height : `${props.height}px`);
const widthComputed = computed(() => props.width?.includes('%') ? props.width : `${props.width}px`);
</script>

<template>
    <div class="spacer"></div>
</template>

<style scoped lang="scss">
.spacer {
    height: v-bind(heightComputed);
    width: v-bind(widthComputed);
}
</style>
